<script lang="ts">
    import { type IconDef } from './icons'

    // Simple icon renderer for iconify instead of using iconify-icon.
    // The reason is for the consent banner itself to not cause storage in localStorage,

    interface Props {
        // and thus not needing to add Iconify to the banner.
        icon: IconDef
        [key: string]: any
    }

    let { icon, ...rest }: Props = $props()
</script>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 {icon.width} {icon.height}" width="1em" height="1em" {...rest}>{@html icon.body}</svg>
